import { doSwaggerCall } from '../hooks/useSwaggerClient';

// Global state for tracking the current lock
let currentGuestLock = null;

// Initial lock holders cache
let initialLockHolders = [];

// Lock refresh interval
let lockRefreshInterval = null;
const LOCK_REFRESH_MS = 60 * 1000; // 1 minute

/**
 * Try to acquire a soft lock for a guest
 * @param {number} guestId
 * @param {boolean} force
 * @returns {Promise<Object>}
 */
export async function tryAcquireGuestLock(guestId, force = false) {
    try {
        const result = await doSwaggerCall('softlocks', 'acquireLock', {
            data: { itemId: parseInt(guestId, 10), itemType: 'GUEST', force }
        });
        if (result.success) {
            currentGuestLock = { itemId: guestId, itemType: 'GUEST' };
        }
        return result;
    } catch (error) {
        console.error('Failed to acquire guest lock:', error);
        // Don't block login on lock failure
        return { success: true };
    }
}

/**
 * Release the current guest lock
 * @returns {Promise<void>}
 */
export async function releaseGuestLock() {
    if (!currentGuestLock) {
        return;
    }
    try {
        await doSwaggerCall('softlocks', 'releaseLock', {
            data: { itemId: currentGuestLock.itemId, itemType: currentGuestLock.itemType }
        });
    } catch (error) {
        console.error('Failed to release guest lock:', error);
    }
    currentGuestLock = null;
    initialLockHolders = [];
}

/**
 * Start refreshing the lock periodically
 */
export function startLockRefresh() {
    stopLockRefresh(false);
    lockRefreshInterval = setInterval(() => {
        if (currentGuestLock && document.visibilityState === 'visible') {
            doSwaggerCall('softlocks', 'acquireLock', {
                data: {
                    itemId: parseInt(currentGuestLock.itemId, 10),
                    itemType: currentGuestLock.itemType,
                    force: false
                }
            }).catch(err => console.error('Failed to refresh lock:', err));
        }
    }, LOCK_REFRESH_MS);
}

/**
 * Stop refreshing the lock
 */
export function stopLockRefresh(clearLockHolders = true) {
    if (lockRefreshInterval) {
        clearInterval(lockRefreshInterval);
        lockRefreshInterval = null;
        if (clearLockHolders) {
            initialLockHolders = [];
        }
    }
}

export function setInitialLockHolders(lockHolders) {
    initialLockHolders = lockHolders;
}

export function getInitialLockHolders() {
    return initialLockHolders;
}
